<script>
  export let type;
  export let style = '';
</script>

<svg {style} width="8px" viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg">
  {#if type === 'arrow_down'}
    <path
      d="M6.59088 6.34661C6.46784 6.22275 6.29968 6.1522 6.12493 6.1522C5.95019 6.1522 5.78205 6.22275 5.65899 6.34661L4.15619 7.85599V1.5625C4.15619 1.19991 3.86252 0.90625 3.49994 0.90625C3.13735 0.90625 2.84369 1.19991 2.84369 1.5625V7.85599L1.34088 6.34661C1.0833 6.08903 0.666596 6.08903 0.40901 6.34661C0.151424 6.6042 0.151424 7.0209 0.40901 7.27849L3.03401 9.90349C3.09635 9.96337 3.17018 10.0101 3.25056 10.0413C3.4097 10.1118 3.59017 10.1118 3.74931 10.0413C3.8297 10.0101 3.90353 9.96337 3.96586 9.90349L6.59086 7.27849C6.71473 7.15544 6.78527 6.98728 6.78527 6.81254C6.78527 6.6378 6.71473 6.46965 6.59086 6.34659L6.59088 6.34661Z"
      fill="black" />
  {/if}
</svg>
